export default __webpack_public_path__ + "static/media/babe-ruth.df7f6e6c.png";